import { ref } from 'vue';
import { createApolloClient } from '@/components/commons/apollo.js';
import useEventHook from './useEventHook.js';

/**
 *  Execute a mutation operation to fetch data from the GraphQL API endpoint.
 * @param {string} mutation GraphQL mutation to be executed
 */
export default function useMutation(mutation) {
  const loading = ref(false);
  const called = ref(false);
  const error = ref(null);

  const doneEvent = useEventHook();
  const errorEvent = useEventHook();

  const client = createApolloClient(import.meta.env.SSR);

  // TODO: check if default options are required by Apollo client
  const currentOptions = {};

  async function mutate(variables, overrideOptions) {
    error.value = null;
    loading.value = true;
    called.value = true;

    try {
      const result = await client.mutate({
        mutation,
        ...currentOptions,
        ...overrideOptions,
        variables: {
          ...(variables || {}),
        },
      });

      loading.value = false;
      called.value = false;
      doneEvent.trigger(result);
      return result;
    } catch (e) {
      error.value = e;
      loading.value = false;
      errorEvent.trigger(e);
      throw e;
    }
  }

  return {
    mutate,
    loading,
    called,
    error,
    onDone: doneEvent.on,
    onError: errorEvent.on,
  };
}
